export default __webpack_public_path__ + "96759856b4e70f3a83385d07e0d33b03.woff";